export const APPOINTMENT_STATUS = {
  MISSING: 'MISSING',
  ON_TIME: 'ON_TIME',
  EARLY: 'EARLY',
  LATE: 'LATE',
}
